import { apiFetch } from './api';

/**
 * Get customer notification settings (admin-controlled toggles for emails/in-app sent to customers)
 */
export async function getCustomerNotificationSettings() {
  const res = await apiFetch('/api/admin/settings/notifications');
  return res?.data ?? { customerNotificationPrefs: {}, customerNotificationTypes: [] };
}

/**
 * Update customer notification settings
 * @param {Object} customerNotificationPrefs - Map of type key to { email: boolean, inApp: boolean }
 */
export async function updateCustomerNotificationSettings(customerNotificationPrefs) {
  const res = await apiFetch('/api/admin/settings/notifications', {
    method: 'PUT',
    body: { customerNotificationPrefs }
  });
  return res?.data ?? { customerNotificationPrefs: {}, customerNotificationTypes: [] };
}
